<template>
  <div class="user-index">
    <div class="title">
      <span>用户列表</span>
      <mu-button class="add-btn" color="purple" @click="addOpen = true">
        <mu-icon value="add" :size="20"></mu-icon>
        新增用户
      </mu-button>
    </div>
    <mu-form :model="form" label-width="80" class="form" :inline="true">
      <mu-form-item prop="search" label="搜索" label-position="left">
        <mu-text-field
          v-model="form.keyword"
          help-text="请输入搜索内容"
        ></mu-text-field>
      </mu-form-item>
      <mu-form-item>
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          搜索
        </mu-button>
      </mu-form-item>
    </mu-form>
    <mu-paper :z-depth="1">
      <mu-data-table
        :columns="columns"
        :data="list"
        stripe
        class="table"
        :loading="loading"
      >
        <template slot-scope="scope">
          <td>{{ scope.row.userName }}</td>
          <td>{{ scope.row.realName }}</td>
          <td>{{ scope.row.type }}</td>
          <td>{{ scope.row.role ? scope.row.role.name : '' }}</td>
          <td>{{ scope.row.phone }}</td>
          <td>
            <mu-button color="indigo400" @click="mp(scope.row)">
              <mu-icon left value="verified_user" :size="20"></mu-icon>
              公众号授权
            </mu-button>
            <mu-button color="success" @click="password(scope.row)">
              <mu-icon left value="edit" :size="20"></mu-icon>
              修改密码
            </mu-button>
            <mu-button color="info" @click="edit(scope.row)">
              <mu-icon left value="edit" :size="20"></mu-icon>
              编辑
            </mu-button>
            <mu-button color="secondary" @click="deleteOne(scope.row)">
              <mu-icon left value="delete" :size="20"></mu-icon>
              删除
            </mu-button>
          </td>
        </template>
      </mu-data-table>
    </mu-paper>
    <div class="page">
      <div class="info">共{{ total }}条记录</div>
      <mu-pagination
        raised
        :total="total"
        :current.sync="form.page"
        :page-size="15"
        @change="getAll"
      ></mu-pagination>
    </div>
    <Create :open.sync="addOpen" @finish="getAll()"></Create>
    <Update :open.sync="editOpen" :form="editForm" @finish="getAll()"></Update>
    <Password :open.sync="passwordOpen" :user="passwordItem"></Password>
    <mp :open.sync="mpOpen" :user="mpUser"></mp>
  </div>
</template>

<script>
import Create from './create'
import Update from './update'
import Password from './password'
import mp from './mp'
import backend from 'utils/backend'
import api from '@/api'
export default {
  components: { Create, Update, Password, mp },
  data() {
    return {
      loading: false,
      addOpen: false,
      editOpen: false,
      editForm: {},
      passwordOpen: false,
      passwordItem: {},
      mpOpen: false,
      mpUser: {},
      form: {
        keyword: '',
        page: 1,
        relations: ['user.role']
      },
      total: 1,
      columns: [
        {
          title: '用户名',
          name: 'userName',
          align: 'center'
        },
        {
          title: '真实姓名',
          name: 'realName',
          align: 'center'
        },
        {
          title: '用户类型',
          name: 'type',
          align: 'center'
        },
        {
          title: '角色',
          name: 'group',
          align: 'center'
        },
        {
          title: '手机',
          name: 'phone',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          width: 500
        }
      ],
      list: []
    }
  },
  methods: {
    edit(item) {
      this.editForm = item
      this.editOpen = true
    },
    deleteOne(item) {
      this.$confirm('确定要删除？', '提示', {
        type: 'warning'
      }).then(({ result }) => {
        if (result) {
          backend(api.user.delete, { id: item.id }).then((result) => {
            if (result.statusCode === 200) {
              this.$toast.success('删除成功')
              this.getAll()
            }
          })
        }
      })
    },
    getAll() {
      this.loading = true
      backend(api.user.getAll, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.loading = false
          this.list = result.data.rows
          this.total = result.data.count
        }
      })
    },
    password(item) {
      this.passwordOpen = true
      this.passwordItem = item
    },
    mp(user) {
      this.mpUser = user
      this.mpOpen = true
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="less" scoped>
.user-index {
  position: relative;
  .title {
    font-size: 20px;
    margin-bottom: 10px;
    line-height: 36px;
    .add-btn {
      margin-left: 20px;
    }
  }
  .table {
    td {
      text-align: center;
    }
  }
  .page {
    position: absolute;
    right: 30px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    padding-bottom: 30px;
    .info {
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/index.vue